tableFieldsDirective = angular.module('tablefields.setting', [])

tableFieldsDirective.directive "tableFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "ContentEditable", ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, ContentEditable) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/tablefields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass
    scope.table = angular.copy scope.data

    sectionId = blockEditDialog.getSectionId id:id
    # Widget.getWidget(sectionId, id).then (data) ->
      # scope.table = data
      # generateTable()

    widgetElWrapper.find("a").click (e) ->
      e.preventDefault()

    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.table.items_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    scope.currentField = getNotDestroyedFieldRnd()

    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length

    scope.setCurrentImage = ($index) ->
      scope.currentField = $index

    generateTRHead = ->
      if scope.data.show_description
        descriptionHTML = "<td itemprop='description'><div contenteditable='false' spellcheck='false' data-access='description_title'>#{scope.data.description_title}</div></td>"
      if scope.data.show_extra
        extraHTML = "<td><div contenteditable='false' spellcheck='false' data-access='extra_title'>#{scope.data.extra_title}</div></td>"
      if scope.data.show_price
        priceHTML = "<td itemprop='offers' itemscope='' itemtype='http://schema.org/Offer'>
        <div contenteditable='false' spellcheck='false' data-access='price_title'>#{scope.data.price_title}
        <meta itemprop='price' content='#{scope.data.price_title}'>
        </div></td>"
      if scope.data.show_button
        buttonHTML = "<td></td>"

      HTML = "<tr itemscope='' itemtype='http://schema.org/Product'>
        <td itemprop='name'><div contenteditable='false' spellcheck='false' data-access='name_title'>#{scope.data.name_title}</div></td>
        #{descriptionHTML || ""}
        #{extraHTML || ""}
        #{priceHTML || ""}
        #{buttonHTML || ""}
        </tr>"
      HTML

    generateTRbody = (newRow, index) ->
      if scope.data.show_description
        descriptionHTML = "<td itemprop='description'><div contenteditable='false' spellcheck='false' data-access='items_attributes.#{index}.description'>#{newRow.description}</div></td>"
      if scope.data.show_extra
        extraHTML = "<td><div contenteditable='false' spellcheck='false' data-access='items_attributes.#{index}.extra'>#{newRow.extra}</div></td>"
      if scope.data.show_price
        priceHTML = "<td itemprop='offers' itemscope='' itemtype='http://schema.org/Offer'>
        <div contenteditable='false' spellcheck='false' data-access='items_attributes.#{index}.price'>#{newRow.price}
        <meta itemprop='price' content='#{newRow.price}'>
        </div></td>"
      if scope.data.show_button
        buttonHTML = "<td class='ul-w-price-item-button'><a role='button' href='javascript: void(0)' contenteditable='false' spellcheck='false' data-access='items_attributes.#{index}.caption'>#{newRow.caption}</a></td>"

      HTML = "<tr data-item-id='#{newRow.id}' itemscope='' itemtype='http://schema.org/Product'>
        <td itemprop='name'><div contenteditable='false' spellcheck='false' data-access='items_attributes.#{index}.name'>#{newRow.name}</div></td>

        #{descriptionHTML || ""}
        #{extraHTML || ""}
        #{priceHTML || ""}
        #{buttonHTML || ""}

        </tr>"
      HTML

    scope.add = ->
      sectionId = blockEditDialog.getSectionId id:id
      params =
        items_attributes: [{
          is_temp: true
        }]
      Widget.createItem(sectionId, id, params).then (data) ->
        newRow = data.items_attributes[data.items_attributes.length-1]
        scope.table.items_attributes.push newRow
        length = scope.table.items_attributes.length
        HTML = generateTRbody(newRow, length-1)
        widgetElWrapper.find(".str-bw_table-body").append HTML
        scope.setCurrentImage length - 1
        ContentEditable.bind false, true, id


    changeDesign = (design) ->
      widgetElWrapper.find("table").removeClass("str-bw_table-design-1")
      widgetElWrapper.find("table").removeClass("str-bw_table-design-2")
      widgetElWrapper.find("table").addClass("str-bw_table-design-#{design}")



    scope.remove = ->
      scope.table.items_attributes[scope.currentField]._destroy = true
      widgetElWrapper.find("[data-item-id='#{scope.table.items_attributes[scope.currentField].id}']").remove()

      scope.setCurrentImage getNotDestroyedFieldRnd()

    generateTable = ->
      HTML = ""
      _.each scope.table.items_attributes, (row, index) ->
        HTML += generateTRbody(row, index)
      headHTML = generateTRHead()
      widgetElWrapper.find("thead").html headHTML
      widgetElWrapper.find("tbody").html HTML
      ContentEditable.bind false, true, id

    listener1 = scope.$watch "data", (newVal, oldVal) ->
      return
    , true

    listener2 = scope.$watch "table.items_attributes", (newVal, oldVal) ->
      scope.data.items_attributes = newVal
    , true

    listener3 = scope.$watch "data.design", (newVal, oldVal) ->
      changeDesign newVal
    , true

    listener4 = scope.$watch "data.table_style", (newVal, oldVal) ->
      widgetElWrapper.find("table").css newVal
    , true

    listener5 = scope.$watch "data.show_description", (newVal, oldVal) ->
      return false if newVal is oldVal
      generateTable()
      return
    , true

    listener6 = scope.$watch "data.show_extra", (newVal, oldVal) ->
      return false if newVal is oldVal
      generateTable()
      return
    , true

    listener7 = scope.$watch "data.show_button", (newVal, oldVal) ->
      return false if newVal is oldVal

      generateTable()
      return
    , true

    scope.$on "$destroy", ->
      listener1()
      listener2()
      listener3()
      listener4()
      return


]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/tablefields/tablefields.directive.coffee